import {
  Button,
  Grid,
  Card,
} from "@material-ui/core";
import moment from "moment";
import "moment/locale/es";
import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  conveniosActivosPorPractica, limpiarConvenios,
} from "../../../actions/contrataciones/contratacionesConvenios";
import { startAlerta } from "../../../actions/ui/alertas";
import { CATEGORIAS_VALORIZACIONES_ARRAY, TIPOS_VALORIZACIONES } from "../../../utils/constants";
import BuscadorPractica from "./BuscadorPractica";
import TableGeneric from "../../compartidos/abms/TableGeneric";

export const ConveniosPorPractica = (props) => {
  moment.locale("es");
  const dispatch = useDispatch();
  const buscadorRef = useRef(null);

  const { conveniosPorPractica } = useSelector((state) => state.contratacionesConvenios);

  const [codigoPractica, setCodigoPractica] = useState(null)

  const handleConsultar = () => {
    if (!codigoPractica) {
      dispatch(startAlerta("Ingrese un Codigo de practica.", "error"));
    } else {
      dispatch(conveniosActivosPorPractica(codigoPractica.codNom))
    }
  };

  useEffect(() => () => dispatch(limpiarConvenios()), []);
  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BuscadorPractica ref={buscadorRef} cod={codigoPractica} label="Código Practica" fieldsDisabled={false} setCod={(val) => setCodigoPractica(val)} />
        </Grid>

        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            onClick={handleConsultar}
            variant="contained"
            color="primary"
          >
            Consultar
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <TableGeneric
              data={conveniosPorPractica}
              columns={[
                {
                  label: "Fecha Inicio Vigencia",
                  id: "fechaInicioVigencia",
                  sort: true,
                  customBody: (item) => moment(item.fechaInicioVigencia).format('DD/MM/YYYY')
                },
                {
                  label: "Fecha Fin Vigencia",
                  id: "fechaFinVigencia",
                  sort: true,
                  customBody: (item) => moment(item.fechaFinVigencia).format('DD/MM/YYYY')
                },
                {
                  label: "Valor",
                  id: "valor",
                  sort: true,
                  customBody: (item) => "$ " + item.valor
                },
                {
                  label: "Tipo de valorización",
                  id: "idTipoValorizacion",
                  sort: true,
                  customBody: (item) => (
                    <>
                      {item.idTipoValorizacion === TIPOS_VALORIZACIONES.VALOR_FIJO && "Valor Fijo"}
                      {item.idTipoValorizacion === TIPOS_VALORIZACIONES.NBU && "Nbu"}
                      {item.idTipoValorizacion === TIPOS_VALORIZACIONES.NNX && "Nnx"}
                      {item.idTipoValorizacion === TIPOS_VALORIZACIONES.GALENOS_GASTOS && "Nomencladas"}
                    </>
                  )
                },
                {
                  label: "Categoría",
                  id: "idCategoria",
                  sort: true,
                  customBody: (item) => (
                    <>
                    {CATEGORIAS_VALORIZACIONES_ARRAY.find(X=>X.id === item.idCategoria)?.descripcion}
                    </>
                  )
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
